import { Link, useParams } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import axiosInterceptor from '../function/axiosInterceptor';
import { Context } from '../function/Contact';
const Thanks = () => {
    const { info } = useContext(Context)
    const { id } = useParams()
    const [data, setData] = useState({})
    const fatchdata = async () => {
        try{
            const response = await axiosInterceptor.get(`/donation?id=${id}`);
            if(response.status==='success'){ setData(response.data) }
        }catch(err){}
    }
    useEffect(() => { fatchdata() }, [])
    return (<>
        <section className="thnk">
            <div className="cont">
                <div className="text-cnt">
                    <img src='https://api.mnbfoundation.com/img/6122023_9950917.png' className='logosuccess ' />
                    
                    <h3 className='mt-30'>Thank You for Your Donation!</h3>
                    
                    <div className="message">
                       <p>We have received your payment request successfully.</p>

 <h5 className='text-center'>Thank You for Your Donation!</h5>
 <p>Your donation payment is currently <strong>under process.</strong> <br></br>
Our foundation team will verify and confirm the payment shortly.</p>

<p><strong>Confirmation Timeline:</strong></p>
<p>Payment confirmation will be completed <strong>within 24 hours.</strong></p>

<ul class="list-group  payment_status  mb-2">
  <li class="list-group-item d-flex fw-medium justify-content-between align-items-center px-3">
    Name
    <span class="">{data?.name}</span>
  </li>
  <li class="list-group-item d-flex fw-medium justify-content-between align-items-center px-3">
   Amount:
    <span class="">₹{(data?.amount || 0).toFixed(0)}</span>
  </li>
  <li class="list-group-item d-flex fw-medium justify-content-between align-items-center px-3">
   Current Status
    <span class="">⏳ Under Verification</span>
  </li>
 

</ul>
<p>
                            If you have any queries, please feel free to contact us at <br></br><strong>{info?.email}</strong> or call us at <strong>{info?.phone}</strong>.
                        </p>

<hr></hr>

<div className='text-left confirm-email'>
    
<h6>Confirmation via Email</h6>
<span className='text-left' >Once the payment is confirmed by our foundation:</span>
<ul>
<li>You will receive a confirmation email</li>
<li>Your Donation Certificate will be sent via email</li>
<li>Certificate download link will also be provided</li>
</ul>
</div>

 




                       
                        
                       
                        
                    </div>
                    <Link to="/">HOME PAGE</Link>
                </div>
            </div>
        </section>
    </>)
}
export default Thanks;